import React from 'react';
import {useHistory} from 'react-router-dom';

import MuiIcon from 'components/Icons/MuiIcon';

const LockedFeatureModalV2Header = (props) => {
  const {toggle, title, subheader, headerIcon, type, close} = props;

  const {push} = useHistory();

  const onClose = () => {
    toggle?.(type);

    if (type === 'market_intelligence') {
      push('/analytics/iso-survey');
    }
  };

  return (
    <React.Fragment>
      <div className="d-flex justify-content-end">
        {close && (
          <MuiIcon name="close" className="cursor-pointer" onClick={onClose} />
        )}
      </div>

      {(subheader || headerIcon) && (
        <small className="text-muted mb-2 d-flex align-items-center">
          {headerIcon && (
            <MuiIcon
              size="lg"
              name={headerIcon}
              className="text-warning mr-2"
            />
          )}
          {subheader}
        </small>
      )}

      <h4 className="font-weight-bold mb-3">{title}</h4>
    </React.Fragment>
  );
};

export default LockedFeatureModalV2Header;
